
(function () {
    function initAccordion(root) {
      const single = root.getAttribute('data-accordion-single') === 'true';
      const items = Array.from(root.querySelectorAll('[data-acc-item]'));
  
      items.forEach((item) => {
        const btn = item.querySelector('[data-acc-trigger]');
        const panel = item.querySelector('[data-acc-panel]');
        if (!btn || !panel) return;
  
        btn.setAttribute('aria-expanded', 'false');
        panel.classList.add('dy:hidden');
  
        btn.addEventListener('click', () => {
          const isOpen = btn.getAttribute('aria-expanded') === 'true';
  
          if (single) {
            items.forEach((it) => {
              const b = it.querySelector('[data-acc-trigger]');
              const p = it.querySelector('[data-acc-panel]');
              if (b && p && b !== btn) {
                b.setAttribute('aria-expanded', 'false');
                p.classList.add('dy:hidden');

                const svg = b.querySelector('svg');
                if (svg) svg.style.transform = 'rotate(0deg)';
              }
            });
          }
  
          btn.setAttribute('aria-expanded', String(!isOpen));
          panel.classList.toggle('dy:hidden', isOpen);
  
          const svg = btn.querySelector('svg');
          if (svg) svg.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
        });
      });
    }
  
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('[data-accordion]').forEach(initAccordion);
    });
  })();
  